import React, {forwardRef} from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';
import {makeStyles} from '@material-ui/core/styles';
import {ReactComponent as areaIcon} from './controls/area.svg';
import {ReactComponent as centerIcon} from './controls/center.svg';
import {ReactComponent as deleteIcon} from './controls/delete.svg';
import {ReactComponent as directionsIcon} from './controls/directions.svg';
import {ReactComponent as exportIcon} from './controls/export.svg';
import {ReactComponent as filterIcon} from './filter.svg';
import {ReactComponent as folderIcon} from './controls/folder.svg';
import {ReactComponent as fullscreenIcon} from './controls/fullscreen.svg';
import {ReactComponent as importIcon} from './controls/import.svg';
import {ReactComponent as mapLayersIcon} from './controls/map-layers.svg';
import {ReactComponent as myLocationIcon} from './controls/my-location.svg';
import {ReactComponent as openDetailsIcon} from './controls/open-details.svg';
import {ReactComponent as performanceIcon} from './controls/performance.svg';
import {ReactComponent as printIcon} from './controls/print.svg';
import {ReactComponent as routeIcon} from './controls/route.svg';
import {ReactComponent as searchIcon} from './search.svg';
import {ReactComponent as settingsIcon} from './controls/settings.svg';
import {ReactComponent as shareIcon} from './controls/share.svg';
import {ReactComponent as sortIcon} from './sort.svg';
import {ReactComponent as waypointIcon} from './controls/waypoint.svg';
import {ReactComponent as zoomInIcon} from './controls/zoom-in.svg';
import {ReactComponent as zoomOutIcon} from './controls/zoom-out.svg';
import {SPRING_1, GRANITE_1} from '../colors';

const activeColor = SPRING_1;
const defaultColor = GRANITE_1;

// Active and default styles for map control buttons. Using these on parent
// controls will allow `disabled` state styles to be inherited correctly.
export const useMapControlStyles = makeStyles({
    root: {
        color: defaultColor,
    },
    active: {
        color: activeColor,
    },
});

const iconNameMap = {
    area: areaIcon,
    center: centerIcon,
    delete: deleteIcon,
    directions: directionsIcon,
    export: exportIcon,
    filter: filterIcon,
    folder: folderIcon,
    fullscreen: fullscreenIcon,
    import: importIcon,
    'map-layers': mapLayersIcon,
    'my-location': myLocationIcon,
    'open-details': openDetailsIcon,
    performance: performanceIcon,
    print: printIcon,
    route: routeIcon,
    search: searchIcon,
    settings: settingsIcon,
    share: shareIcon,
    sort: sortIcon,
    waypoint: waypointIcon,
    'zoom-in': zoomInIcon,
    'zoom-out': zoomOutIcon,
};

interface GaiaIconProps extends SvgIconProps {
    name: keyof typeof iconNameMap;
}

const GaiaIcon = (props: GaiaIconProps, ref: React.Ref<SVGSVGElement>) => {
    const iconComponent = iconNameMap[props.name];
    return <SvgIcon component={iconComponent} ref={ref} {...props} />;
};

// Ref must be forwarded in order to support SubscriptionTooltip
export default forwardRef(GaiaIcon);
